export default ({ COLORS }) => ({
  container: {
    display: 'flex'
  },
  input: {
    borderRadius: '4px 0 0 4px',
    borderRight: 'none'
  },
  label: {
    cursor: 'pointer',
    color: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '40px',
    height: '40px',
    backgroundColor: COLORS.BLUE.NORMAL,
    borderRadius: '0 4px 4px 0'
  }
})
